import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {Injectable} from '@angular/core';
import * as moment from 'moment';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
  readonly DT_FORMAT = 'w, YYYY';
  constructor(private translator: TranslateService) {
    super();
  }
  parse(value: string): NgbDateStruct {
    if (value) {
      value = value.trim();
      let mdt =  moment(value, this.DT_FORMAT);
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    if (!date) {
      return '';
    }
    const mdt = moment([date.year, date.month - 1, date.day]);

    if (!mdt.isValid()) {
      return '';
    }
    const firstDayOfWeek = mdt.startOf('isoWeek');
    return this.translator.instant('global.week') + ' ' + firstDayOfWeek.isoWeek() + firstDayOfWeek.format(', YYYY');
  }
}

